import React, { useState } from 'react'
import { connect } from 'react-redux'
import { PageHeader, Menu, Dropdown, Button, Tag } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import {getStudentreports} from './../actions/studentreport';
import {getAttendances} from '../actions/attendance';
import Page from './Page';

const Reports = (props) => {
   
    
    
    const store_data = localStorage.getItem('selectedresult') !== null && localStorage.getItem('selectedresult') !== null && localStorage.getItem('selectedresult') !== undefined ? JSON.parse(localStorage.getItem('selectedresult')) : {}
    const reportinfo = store_data.data || {};
    const schoolinfo = store_data.schooldata  || {};
    const claszinfo = store_data.classdata || {};
    const [reports, setreports] = useState(reportinfo)
    const [claszs, setclaszs] = useState(claszinfo)
    const [bundler, setbundler] = useState(true)

    const {composite} = reports || {}
    const {claszid} = claszs || ''
  
    let comp = composite != undefined && composite.length > 0 && JSON.parse(composite) != null && JSON.parse(composite) != undefined ?  JSON.parse(composite) :{}
    
    const merger_array = comp.hasOwnProperty(String(claszid)) ? comp[claszid] : {}
    console.log(merger_array)
     const grouper =(title, array)=> {
         let new_obj = {}
         if(Array.isArray(array)){
         array.forEach(ele => {
             let ky = ele[title]
             ele.score = parseFloat(ele.score)
             ele.maxscore = parseFloat(ele.maxscore)
             if(new_obj.hasOwnProperty(ky)){
                new_obj[ky].push(ele)
             }else{
                new_obj[ky] = []
                new_obj[ky].push(ele) 
             }
         });
        }
         return new_obj 
     }

     const ranker = (subjects, score, rankname)=>{
        let r = {}
        Object.keys(subjects).forEach(rw=>{
            let dta = subjects[rw] //this.filter(r=>parseInt(r.subjectid) === parseInt(rw));
            const d = dta.sort(function(a,b){ return b[score] - a[score]; });
            //console.log(d)
            var arv = rankes(d, score, rankname)
            r[rw] = arv
            //console.log(rw, r[rw])
            arv =[]
        })
        return r
     }
     const ranker1 = (subjects, score, rankname)=>{
        let r = {}
        Object.keys(subjects).forEach(rw=>{
            let dta = subjects[rw] //this.filter(r=>parseInt(r.subjectid) === parseInt(rw));
            const d = dta.sort(function(a,b){ return b[score] - a[score]; });
            //console.log(d)
            var arv = rankes(d, score, rankname)
            r[rw] = arv
            //console.log(rw, r[rw])
            arv =[]
        })
        return r
     }
     const rankes = (d, score, rankname)=>{
        let r = []
        d.forEach(function(player, i, arr) {
            if(i === 0 || player[score] != arr[i-1][score])
            {
                player[rankname] = i + 1
                
            }else{
                player[rankname] = arr[i-1][rankname];
                
            }
            r = [...r, player]
        });
       return r
     }

     const ranks = (data, score, rankname)=>{
            data.sort(function(a,b){ return b[score] - a[score]; });
            data.forEach(function(player, i, arr) {
            player[rankname] = i === 0 || player[score] != arr[i-1][score]
                       ? i + 1
                       : arr[i-1][rankname];
            });
        return data
     }

     const agregator = (subjects, name, scorename)=>{
        let r = {}
        Object.keys(subjects).forEach(rw=>{
            let data = subjects[rw] 
            let store = []
            data.forEach(ele => {
                store.push(ele[scorename])
            });
            r[rw] = store
        })
        let s = []
        Object.keys(r).forEach(ele => {
            let d = r[ele]
            let arr = {}
            arr[name] = ele
            arr['total'] = d.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0)
            arr['pop'] = d.length
            arr['avg'] = d.length > 0 ? d.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0)/ d.length : 0
            arr['max'] = Math.max(...d)
            arr['min'] = Math.min(...d)
            arr['values'] = d
            s.push(arr)
        });
        return s
     }
    
     const arranger = (array, method_array) =>{
        let a = method_array
        let nest = {}
        let nest_w = {}
        let nest_s = {}
        let nest_n = {}
        Object.keys(a).forEach(p=>{
                let suba = a[p].data
                let tot = []
                Object.keys(suba).forEach(q=>{
                    nest[q] = p
                    nest_w[q] = suba[q]
                    tot.push(suba[q])
                })
                nest_s[p] = tot.reduce((a, b)=>parseFloat(a)+parseFloat(b), 0)
                nest_n[p] = a[p].name
        })
        let subjects_to_subtitute = Object.keys(nest) 
        let new_array = []
        let affected_obj = {}
        if(Array.isArray(array)){
        array.forEach(ele => {
            if(subjects_to_subtitute.includes(ele.subjectid.toString()))
            {
                //INVOLVE : GROUP THEM BY SUBJECT AND CA commom id
                let new_subject = nest[ele.subjectid]
                let marker_id = new_subject+"_"+ ele.caid
                if(affected_obj.hasOwnProperty(marker_id)){
                    affected_obj[marker_id].push(ele)
                }else{
                    affected_obj[marker_id] = []
                    affected_obj[marker_id].push(ele)
                }
            }else{
                //NOT INVOLVE SO DO NOTHING
                new_array.push(ele)
            }
        });
    }
        //join affected rows
        Object.keys(affected_obj).forEach(ele=>{
            let data_array = affected_obj[ele];
            //console.log(data_array)
            let subj = ele.split("_")
            let subj_parent = subj[0]
            let subj_total = nest_s[subj_parent]
            let arr = {}
            let subarr = []
            arr['subjectid'] = subj[0]
            arr['subjectname'] = nest_n[subj_parent]
            data_array.forEach(element => {
                let subj_weight = nest_w[element.subjectid]
                let subj_unit = subj_weight/subj_total
                arr['id'] = element.id
                arr['caid'] = element.caid
                arr['caname'] = element.caname
                arr['studentid'] = element.studentid
                let sc = subj_unit * parseFloat(element.score)
                subarr.push(sc)
            });
            arr['score'] = subarr.reduce((a,b)=>a+b,0)
            new_array.push(arr)
        })
        return new_array
     }
     const arranger_aggr = (array, method_array) =>{
        let a = method_array
        let nest = {}
        let nest_w = {}
        let nest_s = {}
        let nest_n = {}
        Object.keys(a).forEach(p=>{
                let suba = a[p].data
                let tot = []
                Object.keys(suba).forEach(q=>{
                    nest[q] = p
                    nest_w[q] = suba[q]
                    tot.push(suba[q])
                })
                nest_s[p] = tot.reduce((a, b)=>parseFloat(a)+parseFloat(b), 0)
                nest_n[p] = a[p].name
        })
        let subjects_to_subtitute = Object.keys(nest) 
        let new_array = []
        let affected_obj = {}
        if(Array.isArray(array)){
        array.forEach(ele => {
            if(subjects_to_subtitute.includes(ele.subjectid.toString()))
            {
                //INVOLVE : GROUP THEM BY SUBJECT AND CA commom id
                let new_subject = nest[ele.subjectid]
                let marker_id = new_subject+"_"+ ele.studentid
                if(affected_obj.hasOwnProperty(marker_id)){
                    affected_obj[marker_id].push(ele)
                }else{
                    affected_obj[marker_id] = []
                    affected_obj[marker_id].push(ele)
                }
            }else{
                //NOT INVOLVE SO DO NOTHING
                new_array.push(ele)
            }
        });
        }
        //join affected rows
        Object.keys(affected_obj).forEach(ele=>{
            let data_array = affected_obj[ele];
            let subj = ele.split("_")
            let subj_parent = subj[0]
            let subj_total = nest_s[subj_parent]
            let arr = {}
            let subarr = []
            arr['subjectid'] = subj[0]
            data_array.forEach(element => {
                let subj_weight = nest_w[element.subjectid]
                let subj_unit = subj_weight/subj_total
                arr['maxscore'] = element.maxscore
                arr['studentid'] = element.studentid
                let sc = subj_unit * parseFloat(element.score)
                subarr.push(sc)
            });
            arr['score'] = subarr.reduce((a,b)=>a+b,0)
            new_array.push(arr)
        })
        return new_array
     }
    

    var student_results = Array.isArray(Object.keys(props.studentreport)) ? props.studentreport[0] || [] : []
    var class_results = Array.isArray(Object.keys(props.studentreport)) ? props.studentreport[1] : []
    const gt = Array.isArray(Object.keys(props.studentreport)) ? props.studentreport[2] : {}  
    const ca_results = Array.isArray(Object.keys(props.studentreport)) ? props.studentreport[5] : {} 
    //START PROCESSING GRADES
    let gt_arr ={}
    if(Array.isArray(gt))
    {
        gt.forEach(ele => {
            let classarray = ele.claszid !== undefined && ele.claszid.length > 0 ? JSON.parse(ele.claszid) : []
            //let classarray = classids !== undefined && classids.length > 0 ? classids.split() : [];
            classarray.forEach(claszid=>{
                if(gt_arr.hasOwnProperty(claszid.value)){
                    gt_arr[claszid.value].push(ele);
                }else{
                    gt_arr[claszid.value] = []
                    gt_arr[claszid.value].push(ele);
                }
            })       
        });
    }
    let all_grades = gt_arr
    let class_grades = all_grades !== undefined && all_grades.hasOwnProperty(claszid) ? all_grades[claszid]: []
   //END PROCESSING GRADES
    if(bundler){
      student_results = arranger(student_results, merger_array)
      class_results = arranger_aggr(class_results, merger_array)
    }
    
    
    const subjects = {}
    const student_data = {}
    const cas = {}
    const bas = {}

    if(Array.isArray(student_results)){
        student_results.forEach(ele => {
        //save subjects
        subjects[ele.subjectid] = ele.subjectname;
        //save cas
        cas[ele.caid] = ele.caname;
        //save scores
        if(student_data.hasOwnProperty(ele.subjectid)){
            if(student_data[ele.subjectid].hasOwnProperty(ele.caid))
            {
            }else{
               student_data[ele.subjectid][ele.caid] = ele.score || 0
            }
        }else{
            student_data[ele.subjectid]  = {}
            student_data[ele.subjectid][ele.caid] = ele.score || 0
        }
        })
    }
    var cs = [...class_results]
    const subject_group = grouper('subjectid', class_results);
    const student_group = grouper('studentid', cs);
    const subject_ranker = ranker(subject_group, 'score', 'rank');
    const subject_agregator = agregator(subject_ranker, 'subjectid', 'score');
    const subject_agregator_ranker = ranks(subject_agregator, 'avg', 'rank');
    const student_ranker = ranker1(student_group, 'score', 'rankz');
    const student_agregator = agregator(student_group, 'studentid', 'score');
    const student_agregator_ranker = ranks(student_agregator, 'avg', 'rank');
    const ca_sum = {}
    if( ca_results !== undefined && Array.isArray(Object.values(ca_results)) && Object.values(ca_results).length > 0){
      Object.values(ca_results).reduce((a,b)=>parseFloat(a) + parseFloat(b), 0)
    }

 
    let data = ''

 //attendance starts
    const dataAtt = Array.isArray(Object.keys(props.attendance)) ? props.attendance[0] || [] : []
    const dataAtt1 = Array.isArray(Object.keys(props.attendance)) ? props.attendance[1] || [] : []
    
   
        var getdates_present = [];
        var getdates_absent = [];
        if(Array.isArray(dataAtt)){
            dataAtt.forEach(prop =>{
            let res = prop.reason.split(",");
            if(res.includes(props.mid))
            {
                getdates_present.push(prop.dates);
            } else{
                getdates_absent.push(prop.dates);
            }
        })
        }
        const others = {}
        if(Array.isArray(dataAtt1)){
        dataAtt1.forEach(prop =>{
            if(others.hasOwnProperty(prop.leaveid)){
                others[prop.leaveid].push(prop.dates)
            }else{
                others[prop.leaveid] = []
                others[prop.leaveid].push(prop.dates)
            }
            
        })
        }
        
        let absent1 = Array.isArray(others[3]) ? others[3].length : 0 //absent with notice
        let absent2 = Array.isArray(others[5]) ?  others[5].length : 0 //absent no notice
        let absent3 = Array.isArray(others[6]) ?  others[6].length : 0 //halfday
        let late = Array.isArray(others[4]) ?  others[4].length : 0
        let total_present = getdates_present.length
        let total_absent = absent1 + absent2 + absent3
        let total_days = total_present + total_absent
        let punctuality = parseInt(total_present) > 0 ? ((total_present - late) / total_present) * 100 : 0
        let attendance =  parseInt(total_days) > 0 ? ((total_days - total_absent) / total_days) * 100 : 0
        let behavior = []

    return (
        <div >
            <Page
                    report={reports}
                    cas={cas}
                    bas={bas} 
                    subject={subjects}
                    studentid={props.mid}
                    rank_student={student_agregator_ranker}
                    rank_subject={subject_agregator_ranker}
                    rank_subjects={subject_ranker}
                    rank_students={student_ranker}
                    student_pop={data}
                    data={student_data}
                    behavior={behavior}
                    cahead ={ca_results}
                    class_grades ={class_grades}
                    ca_sum={ca_sum}
                    attendance={attendance}
                    punctuality={punctuality}
            />
        </div>
    )
}

const mapStateToProps = (state) => ({
    reports:state.reportReducer.reports,
    attendance:state.attendanceReducer.attendances,
    schools:state.reportReducer.schools,
    claszs:state.reportReducer.claszs,
    studentreport:state.studentreportReducer.studentreports,
    mid:state.userReducer.mid
})

const mapDispatchToProps = {
    getStudentreports,
    getAttendances
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
